import { AnalysisCharacter } from '../types';

export interface CharacterVoice {
  voiceUrl: string;
  voiceSource?: AnalysisCharacter['voiceSource'];
  voiceFileName?: string;
  voiceExtractInfo?: string;
}

function toCharacterVoice(character: AnalysisCharacter): CharacterVoice {
  return {
    voiceUrl: character.voiceUrl || '',
    voiceSource: character.voiceSource,
    voiceFileName: character.voiceFileName,
    voiceExtractInfo: character.voiceExtractInfo,
  };
}

export function resolveCharacterVoice(
  characters: readonly AnalysisCharacter[],
): CharacterVoice | undefined {
  const voiced = characters.filter(character => !!character.voiceUrl);
  const selected = voiced.find(character => (character.state || '') === '')
    || voiced.find(character => character.state === 'basic')
    || voiced[0];
  return selected ? toCharacterVoice(selected) : undefined;
}

export function buildCharacterVoiceMap(
  characters: readonly AnalysisCharacter[],
): Map<string, CharacterVoice> {
  const groups = new Map<string, AnalysisCharacter[]>();
  for (const character of characters) {
    const group = groups.get(character.name) || [];
    group.push(character);
    groups.set(character.name, group);
  }
  const voices = new Map<string, CharacterVoice>();
  groups.forEach((states, name) => {
    const voice = resolveCharacterVoice(states);
    if (voice) voices.set(name, voice);
  });
  return voices;
}

export function collapseCharactersWithVoice(
  characters: readonly AnalysisCharacter[],
): AnalysisCharacter[] {
  const voices = buildCharacterVoiceMap(characters);
  const seen = new Set<string>();
  const collapsed: AnalysisCharacter[] = [];
  for (const character of characters) {
    if (seen.has(character.name)) continue;
    seen.add(character.name);
    const voice = voices.get(character.name);
    collapsed.push(voice ? { ...character, ...voice } : { ...character });
  }
  return collapsed;
}
